<mat-card class="no-padding">
  <ng-container *transloco="let t">
    <div>
      <div fxLayoutAlign="end center">
        <div fxFlex>
          <form fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" [formGroup]="searchForm"
            (ngSubmit)="onSearch()" class="details-card-content" style="padding-bottom: 0px;">
            <div fxFlex="25" fxFlex.sm="50" fxFlex.xs="100" class="form-control">
              <mat-form-field appearance="outline">
                <mat-label>{{ t('role.SearchRole') }}</mat-label>
                <input matInput formControlName="name" />
              </mat-form-field>
            </div>
            <div fxFlex="25" fxFlex.sm="50" fxFlex.xs="100" class="form-control">
              <mat-form-field appearance="outline">
                <mat-label>{{ t("siteDetails.status") }}</mat-label>
                <mat-select formControlName="active">
                  <mat-option [value]="null">-- Select --</mat-option>
                  <mat-option *ngFor="let option of statusList" [value]="option.id">{{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex fxFlex.sm="50" fxFlex.xs="100" fxLayout="row" fxLayoutAlign="end center"
              class="form-control button-group">
              <button mat-icon-button color="primary" type="submit" class="sml-button">
                <mat-icon>search</mat-icon>
              </button>

              <button mat-icon-button class="sml-button">
                <mat-icon (click)="reset()">refresh</mat-icon>
              </button>
            </div>
          </form>
          <div fxHide fxShow.gt-sm style="padding: 0 20px;">
            <button mat-icon-button color="primary" (click)="openUserRoleAddDialog()" matTooltip="Add Role">
              <mat-icon>person_add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <mat-table [dataSource]="dataSource" class="propcentra-grid" matSort (matSortChange)="sortData($event)" *ngIf="hasRows" style="padding-top: 0px;">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("role.Role Name") }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="mobile-label">{{ t("role.Role Name") }}</div>
            <div>{{ element.name }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("user.createdBy") }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="mobile-label">{{ t("user.createdBy") }}</div>
            <div>{{ element.createdBy }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="dateCreated">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("user.createdDate") }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="mobile-label">{{ t("user.createdDate") }}</div>
            <div>{{ element.dateCreated }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="statusType">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ t("siteDetails.status") }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="mobile-label">{{ t("siteDetails.status") }}</div>
            <div>{{ element.statusType }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>
            Actions
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button mat-icon-button (click)="onRoleEdit(row)" class="edit-btn">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)"></mat-row>
      </mat-table>
      <mat-paginator *ngIf="hasRows" [pageIndex]="pageIndex" [length]="totalLength" [pageSize]="pageSize"
        (page)="page($event)" [hidePageSize]="true">
      </mat-paginator>
      <div class="no-records-found" *ngIf="!hasRows" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon aria-label="No Role Found">search</mat-icon>
        <p>{{ t("noRecordsFound") }}</p>
      </div>
    </div>
  </ng-container>
</mat-card>